let load = require('./helpers/browser/esm-js-loader-shards')(4);
module.exports = (load("aA0tq")).then(() => parcelRequire('729P0'));